import { ShareWrapper, ShareButton } from "./style/shareButtons";
import { SNSOdl } from "./style";

import { FacebookShareButton, TwitterShareButton } from "react-share";

export default () => (
  <ShareWrapper>
    <TwitterShareButton
      url={typeof window === "object" ? window.location.href : ""}
      style={{ width: "49.9%", height: "70px" }}
    >
      <ShareButton>
        <SNSOdl src="/assets/twitterLogoColor.png" alt="twitter" />
        Share on Twitter
      </ShareButton>
    </TwitterShareButton>
    {/* Division */}
    <div
      style={{
        display: "inline-block",
        minWidth: "0.2%",
        backgroundColor: "#f2f2f2",
        height: `70px`,
        verticalAlign: "middle",
      }}
    >
      <div
        style={{
          height: `35px`,
          backgroundColor: "#ccc",
          position: "relative",
          top: `17.5px`,
        }}
      ></div>
    </div>
    <FacebookShareButton
      url={typeof window === "object" ? window.location.href : ""}
      style={{
        width: "49.9%",
        height: "70px",
      }}
    >
      <ShareButton>
        <SNSOdl src="/assets/facebookLogoColor.png" alt="facebook" />
        Share on Facebook
      </ShareButton>
    </FacebookShareButton>
  </ShareWrapper>
);
